module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<form>\n    <dl class=\'stepped zero\'>\n        <dt>\n            <label for=\'integration_configuration_id\'>' +
((__t = ( i18next.t('glossary.configuration') )) == null ? '' : __t) +
'</label>\n        </dt>\n        <dd>\n            <select class=\'text\' id=\'integration_configuration_id\' name=\'integration[configuration_id]\'></select>\n        </dd>\n        <dt>\n            <label for=\'integration_site_id\'>' +
((__t = ( i18next.t('glossary.site') )) == null ? '' : __t) +
'</label>\n        </dt>\n        <dd>\n            <select class=\'text\' id=\'integration_site_id\' name=\'integration[site_id]\'></select>\n        </dd>\n        <dt>\n            <label for=\'integration_bms\'>' +
((__t = ( i18next.t('integrations.wise_api.bms') )) == null ? '' : __t) +
'</label>\n        </dt>\n        <dd>\n            <input class=\'vertical-middle\' id=\'integration_bms\' name=\'integration[bms]\' type=\'checkbox\'>\n        </dd>\n        <div class="modal-description-container">\n            <span class="modal-description-title">\n                <i class="' +
((__t = ( WiseMetering.icons.info )) == null ? '' : __t) +
'" style="margin-right: 10px; color: #2a81c0; font-size: 2em;" aria-hidden=\'true\'></i>\n            </span>\n            <p style="margin: 0">' +
((__t = ( i18next.t('integrations.wise_api.bms_info') )) == null ? '' : __t) +
'</p>\n        </div>\n    </dl>\n</form>\n';

}
return __p
}